module.exports = __webpack_public_path__ + "images/home-qrcode-com.cb0caf9a.png";